/**
 * @file
 * Pluxee slider title script.
 */

(function ($) {
    'use strict';
    Drupal.behaviors.pluxeeSliderTitle = {
        attach: function (context, settings) {
            $(document).ready(function() {
                let $sliderItems = $(".coh-slider-item:not([data-slick-index='0']) .coh-container .coh-heading");
                $sliderItems.each(function () {
                    this.outerHTML = this.outerHTML.replace("h1","span")
                });
            });
        }
    };
})(jQuery);
